import React, { Component } from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { sliderTeachers } from '../data/teachersData';

class TeacherSlider extends Component {
	constructor(props) {
		super(props);
		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
	}
	next() {
		this.slider.slickNext();
	}
	previous() {
		this.slider.slickPrev();
	}
	render() {
		var settings = {
			arrows: false,
			slidesToShow: 4,
			infinite: true,
			autoPlay: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		};
		return (
			<>
				<div className="sprite-nav">
					<Slider className="team-carousel owl-carousel owl-theme dots-none  " ref={c => (this.slider = c)} {...settings}>
						{sliderTeachers.map((item, index) => (
							<div className="item" key={index}>
								<div className="dlab-box box-frame1 team-box">
									<div className="dlab-thum">
										<Link to={item.link || '/teachers'}>
											<img src={item.image} alt={item.name} />
										</Link>
										<div className="overlay-bx">
											<h5 className="team-title">
												<Link to={item.link || '/teachers'}>{item.name}</Link>
											</h5>
											<span className="team-info">{item.role || 'Faculty'}</span>
										</div>
									</div>
								</div>
							</div>
						))}
					</Slider>
					<div className="owl-nav" style={{ textAlign: "center" }}>
						<div className=" owl-prev " onClick={this.previous} />
						<div className="owl-next " onClick={this.next} />
					</div>
				</div>
			</>
		)
	}
}
export default TeacherSlider;
